import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`My Projects. More on `}<a parentName="h2" {...{
        "href": "https://github.com/yonatangross"
      }}>{`GitHub`}</a></h2>
    <ProjectCard title="Adop(e)t" link="https://github.com/yonatangross/adopet" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Adop(e)t project is a website for pets adoptions.
The website was built with TypeScript, Node.js, React, Angular, MongoDB and other libs.
    </ProjectCard>
    <ProjectCard title="GamingStore" link="https://github.com/yonatangross/GamingStore" bg="linear-gradient(to right, rgb(102, 45, 140) 0%, rgb(237, 30, 121) 100%)" mdxType="ProjectCard">
The Gaming Store project is a website for a gaming store with an online and physical shops.
Built with ASP.NET Core MVC Web Application, ML.NET, D3.js and jQuery.
    </ProjectCard>
    <ProjectCard title="Kader" link="https://github.com/yonatangross/Kader" bg="linear-gradient(to right,rgb(213, 133, 255) 0%, rgb(0, 255, 238) 100%)" mdxType="ProjectCard">
Kader is a social assistance cross platform app, Built with React-Native, TypeScript, React hooks, UI-Kittens Design and other libs. 
    </ProjectCard>
    <ProjectCard title="CourseDependency" link="https://github.com/yonatangross/CourseDependency" bg="linear-gradient(to right, rgb(0, 146, 69) 0%, rgb(252, 238, 33)  100%)" mdxType="ProjectCard">
Self learning Spring Boot project by developing the Course dependency application.
Reads excel files parallel and prerequisites and creates a dependencies graph.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      